import { render, staticRenderFns } from "./DeleteIdentityKeys.vue?vue&type=template&id=04a59a2b"
import script from "./DeleteIdentityKeys.vue?vue&type=script&lang=ts"
export * from "./DeleteIdentityKeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports